<template>
  <div class="h-dialogContainer">
    <div class="row">
      <div class="col-sm-4">
        <div class="h-borderBox height-390">
          <div class="h-borderTree-top">{{$t('Pm.selectResource')}}</div>
            <div class="h-subscriber-input-qry-width">
                 <ejs-textbox :placeholder='SearchHolder' v-model='keywords'  @change="searchNeName">
                    <span class="icon hero-icon hero-icon-search"></span>
                </ejs-textbox>
            </div>
            <div class="h-borderTree-content1">
              <NeTreeForDataSearch ref="NeTreeForDataSearch"   :checkedNodesOfNeTree='checkedNodesOfNeTree'></NeTreeForDataSearch>
            </div>
        </div>
      </div>
      <div class="col-sm-8">
        <div class="h-borderBox height-390">
          <div class="h-borderTree-top">{{$t('Pm.selectIndicator')}}</div>
          <div class="h-borderTree-content">
            <MeasureTreeForDataSearch ref="MeasureTreeForDataSearch" :checkedNodesOfMeasureTree='checkedNodesOfMeasureTree'></MeasureTreeForDataSearch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NeTreeForDataSearch from '../tree/NeTreeForDataSearch';
import MeasureTreeForDataSearch from '../tree/MeasureTreeForDataSearch';


export default {
  name: 'NoRealQuerySearchDialog1.vue',
  props: [
    'nodeData',
    'checkedNodesOfNeTree',
    'checkedNodesOfMeasureTree',

  ],
  components: {
    NeTreeForDataSearch,
    MeasureTreeForDataSearch
  },
  data() {
    return {
        SearchHolder: this.$t('MML.searchHolder'),
       keywords: '',
    };
  },
  methods: {
// 按条件搜索
    searchNeName() {
     
      this.$refs.NeTreeForDataSearch.getNeTreeForDataSearch('101', '',this.keywords);
    },
  },
  mounted() {

  },
  computed: {
     
  }
};
</script>

<style>

</style>
